import { render, staticRenderFns } from "./Ativos.vue?vue&type=template&id=326e0578&scoped=true"
import script from "./Ativos.vue?vue&type=script&lang=js"
export * from "./Ativos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326e0578",
  null
  
)

export default component.exports